import { render, staticRenderFns } from "./Staffing.vue?vue&type=template&id=6d92cc1f&scoped=true"
var script = {}
import style0 from "./Staffing.vue?vue&type=style&index=0&id=6d92cc1f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d92cc1f",
  null
  
)

export default component.exports